import { render, staticRenderFns } from "./FleetData.vue?vue&type=template&id=1ed00490&scoped=true"
import script from "./FleetData.vue?vue&type=script&lang=js"
export * from "./FleetData.vue?vue&type=script&lang=js"
import style0 from "./FleetData.vue?vue&type=style&index=0&id=1ed00490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed00490",
  null
  
)

export default component.exports